"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function buildPages(file) {
  var arr = [];
  for (var i = 1; i <= file.numPages; i++) {
    arr.push({
      key: i,
      file: file
    });
  }return arr;
}

var PDF = function (_Component) {
  _inherits(PDF, _Component);

  function PDF() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PDF);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PDF.__proto__ || Object.getPrototypeOf(PDF)).call.apply(_ref, [this].concat(args))), _this), _this.task = null, _this.loadedUrl = null, _this.file = null, _this.error = null, _this.loaded = 0, _this.total = 100, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PDF, [{
    key: "onProgress",
    value: function onProgress(progressData) {
      if (progressData.total) {
        this.loaded = progressData.loaded;
        this.total = progressData.total;

        if (typeof this.props.onProgress === "function") this.props.onProgress(progressData);
      }
    }
  }, {
    key: "loadPDF",
    value: function loadPDF() {
      var _this2 = this;

      // Destroy any old file
      if (this.file) this.file.destroy();

      // Cancel any old task
      if (this.task) this.task.onProgress = function () {
        return null;
      };

      // Clear this instance
      this.loadedUrl = this.props.url;
      this.error = null;
      this.loaded = 0;
      this.total = 0;
      this.file = null;

      var initObject = this.props.url;

      // If custom headers are passed, add them to the PDFJS init object
      if (this.props.headers) {
        initObject = { httpHeaders: this.props.headers, url: this.props.url };
      }

      // Load the PDF
      var task = window.PDFJS.getDocument(initObject);
      task.onProgress = this.onProgress.bind(this);

      this.task = task;

      return task.then(function (file) {
        // Return if this task has been replaced by a new one
        if (task !== _this2.task) return;

        _this2.file = file;
        if (typeof _this2.props.onComplete === "function") _this2.props.onComplete(buildPages(file), file);
      }).catch(function (error) {
        // Return if this task has been replaced by a new one
        if (task !== _this2.task) return;

        _this2.error = error;
        if (typeof _this2.props.onError === "function") _this2.props.onError(error);else throw error;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.url != this.loadedUrl) this.loadPDF();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadPDF();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.file) this.file.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { style: this.props.style, className: this.props.className },
        this.props.children
      );
    }
  }]);

  return PDF;
}(_react.Component);

PDF.propTypes = {
  onProgress: _propTypes2.default.func,
  onComplete: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  url: _propTypes2.default.string.isRequired,
  headers: _propTypes2.default.object,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};
exports.default = PDF;


//////////////////
// WEBPACK FOOTER
// ../~/react-pdf-pages/lib/PDF.js
// module id = 2813
// module chunks = 2